import { getActivityDateRange } from "@/components/AlgoliaSearch";
import type { RecentlyVisitedItem } from "@/hooks/useRecentlyVisited";

type ActivityRecentlyVisitedSource = {
  id?: string | null;
  title?: string | null;
  createdAt?: string | null;
  allowParticipationStarting?: string | null;
  allowParticipationThrough?: string | null;
  event?: {
    slug?: string | null;
    startsAt?: string | null;
    endsAt?: string | null;
  } | null;
};

export function toActivityRecentlyVisitedItem({
  activityTypeId,
  activityId,
  activity,
  url
}: {
  activityTypeId: string;
  activityId: string;
  activity: ActivityRecentlyVisitedSource | null | undefined;
  url?: string;
}): Omit<RecentlyVisitedItem, "dateTime"> | null {
  if (!activityTypeId || !activityId || !activity?.createdAt || !activity.title) {
    return null;
  }
  if (activity.id !== activityId) {
    return null;
  }

  const overviewPath = `/activities/activity-types/${activityTypeId}/activity/${activityId}`;

  return {
    url: url?.trim() || overviewPath,
    text: activity.title,
    subtext:
      getActivityDateRange({
        objectID: activityId,
        object_type: "Activity",
        title: activity.title,
        allow_participation_starting: activity.allowParticipationStarting ?? null,
        allow_participation_through: activity.allowParticipationThrough ?? null,
        event_start_date: activity.event?.startsAt ?? null,
        event_end_date: activity.event?.endsAt ?? null
      }) ?? "",
    image: activity.event ? "today" : "assignment",
    type: "activities",
    entityId: activityId
  };
}
